import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoAditamentoItem } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ContratoAditamentoItemService extends BaseResourceService<ContratoAditamentoItem> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-aditamento-itens`, injector);
  }
}
